/* @flow */

import {
  templateRoot,
  templateMain,
  templateAside,
} from './style/template.style';
import { tablet } from '@braindate/ui/lib/token/mediaQuery';
import { SMALL_SIDEBAR_WIDTH } from 'src/shared/app/base/component/template/component/sidebar/SideBar.style';

export default {
  root: {
    extend: templateRoot,
  },

  branding: {
    marginTop: 48,
  },

  main: {
    extend: templateMain,

    [tablet]: {
      width: `calc(100% - ${SMALL_SIDEBAR_WIDTH + 20}px)`,
    },
  },

  aside: {
    extend: templateAside,
    display: 'none',
    [tablet]: {
      display: 'block',
    },
  },
};
